import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase";

const SyllabusPdf = () => {
  const [syllabusList, setSyllabusList] = useState([]);

  useEffect(() => {
    const q = query(collection(db, "syllabusUpload"), orderBy("date", "desc"));
    onSnapshot(q, (querySnapshot) => {
      let filesArry = [];
      querySnapshot.forEach((doc) => {
        filesArry.push({ id: doc.id, ...doc.data() });
      });
      setSyllabusList(filesArry);
    });
  }, []);

  const deleteNotice = async (sid) => {
    await deleteDoc(doc(db, "syllabusUpload", sid));
    console.log("Deleted ===>" + sid);
  };



  return (
    <React.Fragment>
      <div className="min-h-screen text-lg font-bold text-center p-3 lg:mr-2 pt-4">
        <div className="grid lg:grid-cols-9 gap-4 sm:grid-cols-5  md:grid-cols-5 grid-cols-3">
          {syllabusList?.map((item, index) => (
            <div key={index}>
              <div className="lg:w-16 lg:h-16 md:w-16 md:h-16 text-xs shadow-lg bg-[#FFFFFF] text-[#000000]  sm:text-sm font-bold sm:text-center rounded-lg  transition duration-700 ease-in-out hover:scale-110 hover:bg-white-600">
                <div className="">
                  <div className="hidden">{++index}</div>
                  <div className="">
                    <a href={item.pictureUrl} target="blank">
                      <img
                        src="../assets/pdf.png"
                        className=" lg:h-16 lg:w-16 md:h-16 md:w-16"
                        alt="pdf"
                      />
                    </a>
                  </div>
                  <h1 className="text-sm">{item.bookName}</h1>
                  <span className="text-sm">{item.className}</span>
                </div>
              </div>
              {/* <div>
                  <button
                    className="text-white bg-red-600 py-1 px-6 rounded-md"
                    onClick={() => deleteNotice(item.id)}
                  >
                    Delete
                  </button>
                  </div> */}
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default SyllabusPdf;
